module.exports = __webpack_public_path__ + "img/a5.bce53d40.png";